import React, { useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import _ from "underscore";
let drawerStackCounter = 1045;
const EdelSidebarDrawer = (props) => {
    var _a, _b, _c;
    const startY = useRef(0);
    const drawerRef = useRef(null);
    const [translateY, setTranslateY] = useState(0);
    const [transition, setTransition] = useState("none");
    const [zIndex, setZIndex] = useState(drawerStackCounter);
    const handleTouchStart = (e) => {
        startY.current = e.touches[0].clientY;
        setTransition("none");
    };
    const handleTouchMove = (e) => {
        var _a, _b;
        const currentY = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientY;
        const diffY = currentY - (startY === null || startY === void 0 ? void 0 : startY.current);
        if (diffY > 0) {
            setTranslateY(diffY);
        }
        const drawerHeight = (_b = drawerRef === null || drawerRef === void 0 ? void 0 : drawerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight;
        const remainingHeight = drawerHeight - diffY;
        if (remainingHeight <= 0.5 * drawerHeight || diffY > 150) {
            props === null || props === void 0 ? void 0 : props.setOpenKey(false);
        }
    };
    const handleTouchEnd = () => {
        setTransition("all 0.3s ease-in-out");
        setTranslateY(0);
        startY.current = 0;
    };
    const onEnterAction = () => {
        // const body = document.querySelector("body"); //shifted the logic in below useefect
        // body.style.overflow = "hidden";
        const drawerElement = document.getElementById("sidebar-backdrop");
        if (props.openKey && drawerElement) {
            drawerElement.addEventListener("touchstart", handleTouchStart);
            drawerElement.addEventListener("touchmove", handleTouchMove);
            drawerElement.addEventListener("touchend", handleTouchEnd);
        }
    };
    useEffect(() => {
        const drawerElement = document.getElementById("sidebar-backdrop");
        if (props.openKey) {
            drawerStackCounter += 2;
            setZIndex(drawerStackCounter);
            setTimeout(() => {
                const backdrops = document.querySelectorAll(".offcanvas-backdrop.show");
                if ((backdrops === null || backdrops === void 0 ? void 0 : backdrops.length) > 0) {
                    const latestBackdrop = backdrops[backdrops.length - 1]; // Get the topmost backdrop
                    latestBackdrop.style.zIndex = `${drawerStackCounter - 1}`;
                }
            }, 100);
        }
        const body = document.body;
        if (props.openKey) {
            body.style.overflow = "hidden";
        }
        else {
            body.style.overflow = "auto";
        }
        return () => {
            // Ensure body overflow is restored when component unmounts
            body.style.overflow = "auto";
        };
    }, [props.openKey]);
    useEffect(() => {
        return () => {
            const backdrops = document.querySelectorAll(".offcanvas-backdrop.show");
            if ((backdrops === null || backdrops === void 0 ? void 0 : backdrops.length) === 0) {
                drawerStackCounter = 1045;
            }
        };
    }, []);
    // Then update the preventPullToRefresh function
    const preventPullToRefresh = (e) => {
        // Check if the drawer is open
        if (!props.openKey)
            return;
        // Get the drawer element
        const drawerElement = drawerRef.current;
        if (!drawerElement)
            return;
        // Check if the target is inside the drawer
        const target = e.target;
        const isInsideDrawer = drawerElement.contains(target);
        // If inside drawer, at top of window, and pulling down - prevent refresh
        if (isInsideDrawer &&
            window.scrollY === 0 &&
            e.touches[0].clientY > startY.current) {
            e.preventDefault();
            // Check if we need to handle the drawer drag-to-close logic
            const currentY = e.touches[0].clientY;
            const diffY = currentY - startY.current;
            if (diffY > 0) {
                setTranslateY(diffY);
                const drawerHeight = drawerElement.offsetHeight;
                if (diffY > 150 || drawerHeight - diffY <= 0.5 * drawerHeight) {
                    props.setOpenKey(false);
                }
            }
        }
    };
    // For the preventPullToRefresh useEffect
    useEffect(() => {
        // Only add the event if drawer is open AND preventPullToRefresh is true
        if ((props === null || props === void 0 ? void 0 : props.preventPullToRefresh) && props.openKey) {
            const handleTouchStartForRefresh = (e) => {
                startY.current = e.touches[0].clientY;
            };
            window.addEventListener("touchstart", handleTouchStartForRefresh, {
                passive: true,
            });
            window.addEventListener("touchmove", preventPullToRefresh, {
                passive: false,
            });
            return () => {
                window.removeEventListener("touchstart", handleTouchStartForRefresh);
                window.removeEventListener("touchmove", preventPullToRefresh);
            };
        }
    }, [props.preventPullToRefresh, props.openKey]);
    const transitionStyle = (props === null || props === void 0 ? void 0 : props.placement) === "bottom"
        ? {
            transform: `translate3d(0px, ${translateY}px, 0px)`,
            transition: transition,
        }
        : {};
    return (React.createElement(Offcanvas, { show: props === null || props === void 0 ? void 0 : props.openKey, scroll: false, onEntered: onEnterAction, onHide: () => props === null || props === void 0 ? void 0 : props.setOpenKey(false), placement: props === null || props === void 0 ? void 0 : props.placement, backdropClassName: props.backdropClassName, style: Object.assign(Object.assign({}, transitionStyle), { zIndex }), className: `custom-offcanvas ${(props === null || props === void 0 ? void 0 : props.standalonePage) ? "open-drawerAs-standalonepage" : ""} ${(_a = props === null || props === void 0 ? void 0 : props.backgroundTheme) !== null && _a !== void 0 ? _a : "bg_white"} ${(_b = props === null || props === void 0 ? void 0 : props.drawerHeightClass) !== null && _b !== void 0 ? _b : "height-100"} ${(props === null || props === void 0 ? void 0 : props.openKey) ? "open-sidebar" : "close-sidebar"}`, backdrop: !props.disableBackdrop },
        React.createElement("div", { className: `edel-sidebar-drawer ${(props === null || props === void 0 ? void 0 : props.standalonePage) ? "open-drawerAs-standalonepage" : ""}  ${(_c = ((props === null || props === void 0 ? void 0 : props.openKey) && (props === null || props === void 0 ? void 0 : props.parentClassname))) !== null && _c !== void 0 ? _c : ""}`, id: "sidebar-backdrop", style: { zIndex: zIndex + 1 }, ref: drawerRef },
            props.arrowClose && (React.createElement("div", { className: "sidebar-closing-btn ", onClick: (e) => {
                    props === null || props === void 0 ? void 0 : props.setOpenKey(false);
                } }, props.customArrow ? (props.customArrow) : (React.createElement("i", { className: "edel-icon-arrow-right1" })))),
            (props === null || props === void 0 ? void 0 : props.placement) === "bottom" && !(props === null || props === void 0 ? void 0 : props.hideDrawerHandle) && (React.createElement("div", { className: `d-flex justify-content-center align-items-center w-100 p-2 ${props.drawerhandleClass && props.drawerhandleClass}` },
                React.createElement("span", { className: "drawer-handle" }))),
            (props === null || props === void 0 ? void 0 : props.header) && (React.createElement(Offcanvas.Header, { className: `p-0 edel-sidebar-drawer-head ${props.drawerheadClass}` }, props.header)),
            React.createElement(Offcanvas.Body, { className: "p-0" }, props.body))));
};
export default React.memo(EdelSidebarDrawer, (prevProps, nextProps) => _.isEqual(prevProps, nextProps));
